import React, { memo } from "react"
import CardLive from "components/CardLive"
import Link from "next/link"
import TypeEvent from "utils/TypeEvent"
import { Swiper, SwiperSlide } from "swiper/react"
import { Navigation } from "swiper"

// eslint-disable-next-line react/display-name
const MySwiper = memo(({ name, events, id, type_block }) => {
  function onChangePerView() {
    switch (type_block) {
      case TypeEvent.LIVE:
        return 4.1
      default:
        return 7
    }
  }

  function onChangePerGroup() {
    if (type_block === TypeEvent.LIVE) {
      return 3
    }
  }

  return (
    <div className="flex flex-col gap-5 max-sm:gap-3">
      {/* <Link href={`/danh-muc/${id}`}> */}
      <Link href={`/schedule`}>
        <div className="w-full flex items-center wapper_see_more justify-between max-lg:mr-4 mr-8">
          <span className="max-sm:text-base max-sm:leading-[22px] text-xl font-semibold text-white">{name}</span>
          <div className={`flex items-center gap-[10px] text-primary text-xs sm:text-sm font-normal whitespace-nowrap`}>
            Xem thêm
          </div>
        </div>
      </Link>
      <div className="relative wapper__swiper__custom">
        <Swiper
          key={"live"}
          slidesPerView={onChangePerView()}
          slidesPerGroup={onChangePerGroup()}
          spaceBetween={24}
          modules={[Navigation]}
          className="mySwiper"
          navigation={true}
          breakpoints={{
            300: {
              slidesPerView: 1.1,
              slidesPerGroup: 1,
              spaceBetween: 12
            },
            430: {
              slidesPerView: 1.3,
              slidesPerGroup: 1,
              spaceBetween: 12
            },
            520: {
              slidesPerView: 1.5,
              slidesPerGroup: 1,
              spaceBetween: 12
            },
            600: {
              slidesPerView: 1.7,
              slidesPerGroup: 1,
              spaceBetween: 12
            },
            660: {
              slidesPerView: 1.9,
              slidesPerGroup: 1,
              spaceBetween: 12
            },
            730: {
              slidesPerView: 2.1,
              slidesPerGroup: 1
            },
            815: {
              slidesPerView: 2.3,
              slidesPerGroup: 2
            },
            890: {
              slidesPerView: 2.5,
              slidesPerGroup: 2
            },
            970: {
              slidesPerView: 2.7,
              slidesPerGroup: 2
            },
            1060: {
              slidesPerView: 2.9,
              slidesPerGroup: 2
            },
            1140: {
              slidesPerView: 3.1,
              slidesPerGroup: 2
            },
            1200: {
              slidesPerView: 2.5,
              slidesPerGroup: 2
            },
            1280: {
              slidesPerView: 2.7,
              slidesPerGroup: 2
            },
            1350: {
              slidesPerView: 2.9,
              slidesPerGroup: 2
            },
            1420: {
              slidesPerView: 3.1,
              slidesPerGroup: 2
            },
            1515: {
              slidesPerView: 3.3,
              slidesPerGroup: 3
            },
            1575: {
              slidesPerView: 3.5,
              slidesPerGroup: 3
            },
            1670: {
              slidesPerView: 3.7,
              slidesPerGroup: 3
            },
            1730: {
              slidesPerView: 3.9,
              slidesPerGroup: 3
            },
            1820: {
              slidesPerView: 4.2,
              slidesPerGroup: 3
            }
          }}
        >
          {events?.length > 0 &&
            events?.map((item) => {
              const { id } = item
              return (
                <SwiperSlide key={id}>
                  <CardLive {...item} />
                </SwiperSlide>
              )
            })}
        </Swiper>
      </div>
    </div>
  )
})

export default MySwiper
